import * as React from 'react'

const Star = ({ filled }) => (
  <svg viewBox="0 0 126.729 126.73" className={`star ${filled ? 'filled' : ''}`}>
    <path d="M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z" />
  </svg>
)

// Five stars plus the wording for whichever value is hovered, falling back to
// the selected one. The scale (values and labels) comes from the form
// definition so the copy lives in config/survey_form.yml.
const StarRating = ({ scale, value, onChange }) => {
  const [hovered, setHovered] = React.useState(null)
  const shown = hovered || value
  const label = scale.find((step) => step.value === shown)

  return (
    <div className="star-rating" onMouseLeave={() => setHovered(null)}>
      {scale.map((step) => (
        <button
          key={step.value}
          type="button"
          className="star-button"
          aria-label={`${step.value} - ${step.label}`}
          aria-pressed={value === step.value}
          onMouseEnter={() => setHovered(step.value)}
          onFocus={() => setHovered(step.value)}
          onBlur={() => setHovered(null)}
          onClick={() => onChange(step.value)}
        >
          <Star filled={shown != null && step.value <= shown} />
        </button>
      ))}
      <span className="star-label">{label ? label.label : ''}</span>
    </div>
  )
}

export default StarRating
